'use client';

import { type FunctionComponent } from 'react';
import classNames from 'classnames/bind';
import { Button, Heading, Image, Text } from '@fff-web/ui-components';
import { ModuleWrapper } from '../ModuleWrapper';
import type { ErrorPageContentProps, ErrorPageProps } from './types';
import styles from './ErrorPage.module.scss';

const cx = classNames.bind(styles);

/**
 * This component is separated only for the sake of displaying
 * it in Storybook because calling a server action in Storybook
 * is not possible.
 */
export const ErrorPageContent: FunctionComponent<
  ErrorPageContentProps & Pick<ErrorPageProps, 'reset'>
> = ({ title, body, cta, image, reset }) => {
  return (
    <ModuleWrapper className={cx('ErrorPage')}>
      {title && (
        <Heading as="h1" size="h1">
          {title}
        </Heading>
      )}
      {body && <Text>{body}</Text>}
      {cta && <Button onClick={reset}>{cta}</Button>}
      {image && <Image {...image} alt={image.alt} />}
    </ModuleWrapper>
  );
};
